import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {compose} from 'redux';
import {
  AppForm,
  AppFormSubmitButton,
  ErrorMessage,
  AppFormField,
} from '../../../components/forms';
import RegisterHeader from '../../../components/headers/register-header';
import {Column, Row} from '../../../components/layout';
import {
  addToGlobalStyles,
  addToWizard,
  setWizard,
} from '../../../store/actions';
import './styles.scss';
import colors from '../../../util/colors';
import * as fonts from '../../../util/fonts';
import {strings} from '../../../util/strings';
import {uriResetPassword, uriSendActivationCode} from '../../../api/endpoints';
import {get, patch, post} from '../../../api/api';
import {uriResendActivationCode} from './../../../api/endpoints';
import * as Yup from 'yup';
import {censorEmail, createGUID, labelsParagraphs} from '../../../util/utility';
import AppErrorMessage from '../../../components/app-error-message';
import ModalTemplate from '../../../components/modal';
import {Icons} from '../../../util/icons';
import Icon from './../../../components/icon/index';
import AppButton from './../../../components/app-button/index';
import AppParagraph from '../../../components/app-paragraph';

export interface ChangePasswordProps {
  wizard: any;
  addToWizard(value: any): void;
  addToGlobalStyles(value: any): void;
  labels: typeof strings.pt.login;
  messageLabels: typeof strings.pt.messages;
  registerLabels: typeof strings.pt.register;
  user: any;
  reduxStrings: typeof strings;
  globalStyles: any;
}

function ChangePassword({
  labels,
  messageLabels,
  registerLabels,
  user,
  reduxStrings,
  globalStyles,
}: ChangePasswordProps) {
  const [getVerificationCode, setVerificationCode] = useState<any>();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [formikContext, setFormikContext] = useState();
  const [valid, setValid] = useState(false);
  const [hoverErrorIcons, setHoverErrorIcons] = useState<any>({
    code: false,
    password: false,
    repeatPassword: false,
  });
  const history = useHistory();

  const [email, setEmail] = useState('');
  const [contactEmail, setContactEmail] = useState('');

  const [sessionGuid, setSessionGuid] = useState('');

  const [requestFailed, setRequestFailed] = useState(false);
  const [requestFailedMessage, setRequestFailedMessage] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [showResentCode, setShowResentCode] = useState(false);

  labelsParagraphs(labels);
  const [viewPassword, setViewPassword] = useState(false);
  const [viewRepeatPassword, setViewRepeatPassword] = useState(false);

  const handlePasswordIconClick = (repeat: boolean) => {
    if (repeat) {
      setViewRepeatPassword(!viewRepeatPassword);
    } else {
      setViewPassword(!viewPassword);
    }
  };

  const featureName = 'ChangePassword';

  const [loginLabels, setLoginLabels] = useState({
    ...strings.pt.login,
    ...labels,
  });

  labelsParagraphs(loginLabels);

  useEffect(() => {
    //set data sent from ForgotPassword.tsx to state
    const email = (history.location.state as any).email;
    const sessionGuid = (history.location.state as any).sessionGuid;
    const contactEmail = (history.location.state as any).contactEmail;
    setEmail(email);
    setContactEmail(contactEmail);
    setSessionGuid(sessionGuid);
  }, []);

  const reSendCode = async () => {
    // const response = await get(uriResendActivationCode(email, sessionGuid));
    await post(
      uriSendActivationCode(),
      JSON.stringify({
        destination: email,
        sessionGuid: sessionGuid,
        buId: null,
      }),
      false,
      featureName,
    )
      .then((res: any) => {
        // setVerificationCode(response);
        setShowResentCode(true);
      })
      .catch((err: any) => {
        console.log('err', err);
      })
      .finally(() => {});
  };

  const validationSchema = Yup.object().shape({
    code: Yup.string().required(messageLabels?.requiredField),
    password: Yup.string()
      .required(messageLabels?.requiredField)
      .matches(
        new RegExp(
          '(?=.*\\d)(?=.*[A-Z])(?=.*[!@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>\\/?]).{12,}',
        ),
        labels?.login_passwordError,
      ),
    repeatPassword: Yup.string()
      .required(messageLabels?.requiredField)
      .oneOf([Yup.ref('password')], messageLabels.passwordsDontMatch),
  });

  const defineOnMouseFunctions = (
    e: React.MouseEvent,
    fieldNamePar: string,
  ) => {
    var elem: HTMLElement = e.target as HTMLElement;
    var icon: HTMLElement = elem.nextSibling as HTMLElement;
    if (icon) {
      icon.onmouseover = function () {
        setHoverErrorIcons({...hoverErrorIcons, [fieldNamePar]: true});
      };
      icon.onmouseout = function () {
        setHoverErrorIcons({...hoverErrorIcons, [fieldNamePar]: false});
      };
    }
  };

  return (
    <Row className="change-password-main-row">
      <Column className="change-password-maincolumn">
        <AppForm
          initialValues={{code: '', password: '', repeatPassword: ''}}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            setRequestFailedMessage('');

            const userInfo = {
              sessionId: sessionGuid,
              code: values.code,
              userName: email,
              newPassword: values.password,
              confirmationPassword: values.repeatPassword,
            };
            await patch(uriResetPassword(), userInfo, featureName)
              .then(() => {
                setShowSuccessModal(true);
              })
              .catch((err: any) => {
                console.log('err', err);
                if (err.data.result.message.includes('recent history')) {
                  setRequestFailedMessage(
                    registerLabels.changePassword_passwordUsed,
                  );
                } else {
                  setRequestFailedMessage(
                    registerLabels.register_wrongActivationCode,
                  );
                }
                setRequestFailed(true);
              });
          }}>
          <RegisterHeader />
          <Row className="justify-content-center w-100">
            <p
              className="change-password-title"
              style={{
                ...fonts.XL,
                color: colors.black,
                fontWeight: 'bold',
              }}>
              {labels?.login_changePassword}
            </p>
          </Row>
          <Row className="change-password-subtitle">
            {labels?.login_changePassword_insertCode}
          </Row>
          <Row
            className="change-password-row-input"
            style={{position: 'relative'}}>
            <AppFormField
              showErrorMessage
              className="change-password-input"
              name="code"
              placeholder={labels?.login_changePassword_confirmationCode}
              type="text"
              onInput={() => {
                if ((formikContext as any)?.errors?.code) {
                  (formikContext as any)?.setFieldError('code', undefined);
                }
              }}
              onMouseOver={(e) => defineOnMouseFunctions(e, 'code')}
            />
          </Row>
          <Row className="change-passoword-error">
            <ErrorMessage
              visible={requestFailed}
              error={requestFailedMessage}
            />
          </Row>
          <Row className="change-password-resend-code justify-content-center">
            <p
              style={{
                ...fonts.M,
                color: globalStyles?.primaryColor,
                fontWeight: 'bold',
              }}
              onClick={reSendCode}>
              {labels?.login_changePassword_sendNewCode}
            </p>
          </Row>
          <ModalTemplate
            show={showResentCode}
            onHide={() => setShowResentCode(false)}
            cross={false}
            hideFooter={true}
            className="success-modal-container">
            <div className="submitted-modal-container">
              <Icon
                name={Icons.SUCCESS}
                width={'40'}
                height={'40'}
                color={colors.green}
                changeViewbox
                viewBox={'0 0 24 24'}
              />
              <Row style={{...fonts.Bold}}>
                {registerLabels.activation_sendNewCode_sucess}
              </Row>
              <Row>{registerLabels.activation_sendNewCode_sent}</Row>
              <Row className="resent-modal-button-row">
                <AppFormSubmitButton
                  title={labels?.insertCode_okButton}
                  className="resent-modal-ok-button"
                  variant="secondary"
                  onClick={() => {
                    setShowResentCode(false);
                  }}
                />
              </Row>
            </div>
          </ModalTemplate>
          <Row className="justify-content-center">
            <div className="change-password-separatorline"></div>
          </Row>
          <Row
            className="change-password-row-input"
            style={{position: 'relative'}}>
            <AppFormField
              showErrorMessage
              className="change-password-input"
              name="password"
              type={viewPassword ? '' : 'password'}
              passwordIcon={true}
              pwdIconClass="recover-password-eye"
              handlePasswordIconClick={() => handlePasswordIconClick(false)}
              showPassword={viewPassword}
              placeholder={loginLabels.login_changePassword_newPassword}
              handleFormikContext={(formik) => {
                if (
                  !!!formikContext ||
                  formik.errors !== (formikContext as any).errors
                ) {
                  setFormikContext(formik);
                }
              }}
              onMouseOver={(e) => {
                defineOnMouseFunctions(e, 'password');
              }}
              autoComplete="new-password"></AppFormField>
          </Row>
          <Row
            className="change-password-row-input"
            style={{position: 'relative'}}>
            <AppFormField
              showErrorMessage
              className="change-password-input"
              name="repeatPassword"
              type={viewRepeatPassword ? '' : 'password'}
              passwordIcon={true}
              pwdIconClass="recover-password-eye"
              handlePasswordIconClick={() => handlePasswordIconClick(true)}
              showPassword={viewRepeatPassword}
              placeholder={loginLabels.login_changePassword_repeatNewPassword}
              onMouseOver={(e) => {
                defineOnMouseFunctions(e, 'repeatPassword');
              }}></AppFormField>
          </Row>
          <Row className="change-password-info">
            <p
              style={{
                ...fonts.M,
                color: colors.black,
              }}>
              {labels?.login_changePassword_infoAdvancecare}
            </p>
          </Row>
          <Row className="justify-content-center">
            <AppFormSubmitButton
              className="change-password-button"
              title={labels?.login_changePassword_change}
            />
          </Row>
        </AppForm>
        <ModalTemplate
          show={showSuccessModal}
          onHide={() => history.push('/')}
          cross={false}
          hideFooter={true}
          className="success-modal-container">
          <Row
            className="success-modal-title"
            style={{fontSize: '24px', fontWeight: 'bolder'}}>
            {labels?.login_changePassword}
          </Row>
          <div className="submitted-modal-container">
            <Icon
              name={Icons.SUCCESS}
              width={'40'}
              height={'40'}
              color={colors.green}
              changeViewbox
              viewBox={'0 0 24 24'}
            />
            <Row>{labels?.login_changePassword_pwdChanged}</Row>
            <Row className="submitted-modal-button-row">
              <AppButton
                className="success-modal-button"
                variant="secondary"
                onClick={() => {
                  history.push('/');
                }}>
                <p className="success-modal-ok-button">Ok</p>
              </AppButton>
            </Row>
          </div>
        </ModalTemplate>
        <ModalTemplate
          show={showErrorModal}
          onHide={() => setShowErrorModal(false)}
          cross={false}
          hideFooter={true}
          className="success-modal-container">
          <Column className="error-popup-clm">
            <Row className="error-popup-title-row">
              <Icon
                className="errorPopup-icon"
                name={Icons.ALERT_PROBLEM}
                width="18"
                height="25"
                color={colors.alertRed}
              />
            </Row>
            <Row className="error-popup-title-row">
              <AppParagraph
                style={{...fonts.MM, ...fonts.Bold, color: colors.alertRed}}
                className="p-error-popup"
                label={labels?.login_errorRequestNewCode}></AppParagraph>
            </Row>
            <Row className="error-popup-button">
              <AppButton
                onClick={() => {
                  setShowErrorModal(false);
                }}
                variant="secondary">
                {labels?.insertCode_okButton}
              </AppButton>
            </Row>
          </Column>
        </ModalTemplate>
      </Column>
    </Row>
  );
}

const mapStateToProps = ({
  wizard,
  user,
  globalStyles,
  stringsDefault,
}: any) => ({
  wizard: wizard.value,
  user: user.value,
  labels: stringsDefault.value.pt.login,
  messageLabels: stringsDefault.value.pt.messages,
  registerLabels: stringsDefault.value.pt.register,
  reduxStrings: stringsDefault.value,
  globalStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ChangePassword),
);
